// Klient Better Auth (pod /v1/auth/*): email + heslo, magic link, sociální přihlášení, impersonace.
import { createAuthClient } from 'better-auth/vue'
import { adminClient, magicLinkClient, organizationClient } from 'better-auth/client/plugins'
import { API_PREFIX } from '@wac-buddy/shared'

const apiOrigin = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')

export const authClient = createAuthClient({
  baseURL: apiOrigin || window.location.origin,
  basePath: `${API_PREFIX}/auth`,
  plugins: [organizationClient(), magicLinkClient(), adminClient()],
})
